import React from "react";

import Styles from "./TableCourseModules.module.css";

import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

const useStyles = makeStyles((theme) => ({
	tableActions: {
		width: "100%",
	},
}));

const TableCourseModules = (props) => {
	const classes = useStyles();

  console.log("props.modules", props.modules)

	return (
		<div className={Styles["TableCourseModules"]}>
			<Table className={Styles["Table"]} aria-label="Actions table">
				<TableHead>
					<TableRow className={Styles["MuiTableRow-head"]}>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>
								Nome do Módulo
							</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>Duração</div>
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{props.modules.map((row) => (
						<TableRow
							key={row.id}
							className={Styles["MuiTableBody-root"]}
						>
							<TableCell
								className={Styles["MuiTableCell-root"]}
								align="left"
							>
								<div className={Styles["subtitle"]}>
									{row.name}
								</div>
							</TableCell>
							<TableCell
								className={Styles["MuiTableCell-root"]}
								align="left"
							>
								<div
									className={Styles["subtitle"]}
								>{`${row.duration} H`}</div>
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</div>
	);
};

export default TableCourseModules;
